enum EVENTS {
    LOADER = <any> 'LOADER',
    MAP_RESIZE = <any> 'MAP_RESIZE',
}

export default EVENTS;


// WEBPACK FOOTER //
// ./src/app/enums/events.enum.ts